module.exports = __webpack_public_path__ + "static/kyrstin-huxtable-b80db8d4d841e1930be64cc6a77cdf04.jpg";